function handleDate(date) {
  const newDate = new Date(date);
  const year = newDate.getFullYear();
  const month = newDate.getMonth() + 1;
  const day = newDate.getDate();
  const finalDate = `${day}/${month}/${year}`;
  return finalDate;
}
function getWidth() {
  const width = window.innerWidth;
  return width;
}
function parseAdress(adressInfo, country) {
  if (country === 'co' || country == 'ec' || country == 'cr' || country == 'pe' || country == 'hn' || country == 'ni' || country == 'sv' || country == 'gu') {
    const { addressLine1, addressLine2, locality, adminArea1, adminArea2, country, postalCode, infoExtra } = adressInfo;
    console.log('cuando esta formando el producto', postalCode);
    const finalAdress = {
      addressLine1,
      addressLine2: `${addressLine2}`,
      locality,
      adminArea1,
      adminArea2,
      country,
      placeName: infoExtra,
      postalCode: postalCode.code,
    };
    return finalAdress;
  }
  if (country === 'mx') {
    const { addressLine1, addressLine2, locality, adminArea1, adminArea2, country, postalCode, infoExtra } = adressInfo;
    const finalAdress = {
      addressLine1,
      addressLine2: `${addressLine2}`,
      locality,
      adminArea1,
      adminArea2,
      country,
      placeName: infoExtra,
      postalCode: postalCode.code,
    };
    return finalAdress;
  }
}
function parseStates(entryState) {
  let state = '';
  switch (entryState) {
    case 'confirm_received':
      state = 'Entrega confirmada';
      break;
    case 'pending':
      state = 'Pendiente';
      break;
    case 'processing':
      state = 'Procesando';
      break;
    case 'central_xfer':
      state = 'En la central';
      break;
    case 'acepted':
      state = 'Aceptado';
      break;
    case 'cancelled':
      state = 'Cancelado';
      break;
    case 'delivered':
      state = 'Entregado';
      break;
    case 'created':
      state = 'Creado';
      break;
    case 'retry_central_xfer':
      state = 'Volviendo a la central';
      break;
  }
  return state;
}

export { parseStates as a, getWidth as g, handleDate as h, parseAdress as p };
